import {Avatar, createStyles, Group, Menu, UnstyledButton, Text} from "@mantine/core";
import {ChevronDown, Logout, Settings, SwitchHorizontal} from "tabler-icons-react";
import {useState} from "react";
import useUserStore from "../../../data/User.store";

const useStyles = createStyles((theme) => ({
    userMenu: {
        [theme.fn.smallerThan('xs')]: {
            display: 'none',
        },
    },

    user: {
        color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,
        padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
        borderRadius: theme.radius.sm,
        transition: 'background-color 100ms ease',

        '&:hover': {
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
        },
    },

    userActive: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
    },
}));


function UserButton() {
    const { classes, cx } = useStyles();
    const { user, logout } = useUserStore();
    const [userMenuOpened, setUserMenuOpened] = useState(false);
    return (
        <Menu
            size={260}
            placement="end"
            transition="pop-top-right"
            className={classes.userMenu}
            onClose={() => setUserMenuOpened(false)}
            onOpen={() => setUserMenuOpened(true)}
            control={
                <UnstyledButton
                    className={cx(classes.user, {[classes.userActive]: userMenuOpened})}
                >
                    <Group spacing={7}>
                        <Avatar src={user!.image} alt={user!.name} radius="xl" size={20}/>
                        <Text weight={500} size="sm" sx={{lineHeight: 1}} mr={3}>
                            {user!.name}
                        </Text>
                        <ChevronDown size={12}/>
                    </Group>
                </UnstyledButton>
            }
        >
            <Menu.Label>Settings</Menu.Label>
            {/*<Menu.Item icon={<Settings size={14}/>}>Account settings</Menu.Item>*/}
            {/*<Menu.Item icon={<SwitchHorizontal size={14}/>}>Change account</Menu.Item>*/}
            <Menu.Item icon={<Logout size={14}/>} onClick={logout}>Logout</Menu.Item>
        </Menu>
    )
}

export default UserButton;